import { lotFromFirestore } from '@parallel-fluidics/shared/models/lots';
import { doc, getDoc, getFirestore } from 'firebase/firestore';

export default async function fetchLot(lotId) {
  const lotDoc = await getDoc(doc(getFirestore(), 'lots', lotId));
  if (lotDoc.exists()) {
    return lotFromFirestore(lotDoc);
  }
  throw new Error('Lot not found');
}
